export default __webpack_public_path__ + "static/media/Padron_Churchill_Open.f694b0aa.jpg";